import messageActions from './actions';
import wsActions from '../websockets/actions';

import Socket from '../../utils/webSocketsMiddleware/socketConnection';

const emitNewMessage = ({ message }) => (dispatch, getState) => {
  // TODO
  const { user: { user: { id } } } = getState();
};

const onTyping = () => (dispatch, getState) => {
  // TODO
  const { user: { user: { id } } } = getState();
};

const sendNewMessage = () => () => {
  try {
    console.log('success');
  } catch (e) {
    console.log('error');
  }
};

export default {
  sendNewMessage,
  emitNewMessage,
  onTyping };



// WEBPACK FOOTER //
// ./src/reducers/messages/operations.js